<!-- 园区信息组件 -->
<template>
    <div class="pageContent">
        <CommonRow :title="$t('page.parkInfo.parkName')">
            <div class="whiteCard">
                <div class="whiteCardText">{{ parkInfo.name || "-" }}</div>
            </div>
            <div class="parkBox">
                <CommonCard :title="$t('page.parkInfo.parkArea')"
                    :content="`${parkInfo.area || 0}${$t('page.parkInfo.parkAreaUnit')}`"
                    :icon="'icon-mianjiceliang_mianjiceliang'" />
                <CommonCard :title="$t('page.parkInfo.parkUser')" :content="`${parkInfo.realName || '-'}`"
                    :icon="'icon-yuangongfuzeren'" />
                <CommonCard :title="$t('page.parkInfo.parkPhone')" :content="`${handlePhone(parkInfo.phone)}`"
                    :icon="'icon-dianhua'" />
            </div>
        </CommonRow>
        <CommonRow :title="$t('page.parkInfo.parkAddress')">
            <div class="whiteCard">
                <div class="whiteCardText">{{ parkInfo.address || "-" }}</div>
            </div>
        </CommonRow>
        <CommonRow :title="$t('page.parkInfo.parkRemark')">
            <div class="whiteCard">
                <div class="whiteCardText">{{ parkInfo.introduce || "-" }}</div>
            </div>
        </CommonRow>
        <CommonRow :title="$t('page.parkInfo.parkImage')">
            <template v-if="parkInfo.list && parkInfo.list.length > 0">
                <div class="parkImgBox">
                    <CommonImageCard v-for="item in parkInfo.list" :key="item.id" :src="handleImage(item.image)"
                        :width="'87px'" :height="'70px'" />
                </div>
            </template>
            <template v-else>
                <CommonEmpty :description="$t('empty.noParkImage')" />
            </template>
        </CommonRow>
    </div>
</template>

<script>
import CommonCard from '../common/commonCard.vue';
import CommonImageCard from '../common/commonImageCard.vue';
import { maskPhoneNumber, validateImageUrl } from '../../utils/index';
import { CODE_SUCCESS } from '../../utils/constant.js';
export default {
    components: {
        CommonCard,
        CommonImageCard,
    },
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            parkInfo: {}, // 园区信息
        };
    },
    methods: {
        async refresh() {
            if (!this.info.gardenId) {
                this.parkInfo = {};
                return
            }
            this.$toast.loading({
                message: this.$t("common.loading"),
                forbidClick: true,
            });
            try {
                const params = {
                    id: this.info.gardenId
                }
                const res = await this.$api.fetchGardenInfo(params);
                this.$toast.clear()
                if (res.code != CODE_SUCCESS) {
                    this.$toast.fail(res.msg);
                } else {
                    this.parkInfo = res.data || {};
                }
            } catch (error) {
                this.$toast.clear()
                console.error("错误", error);
            }
        },
        handlePhone(phone) {
            return maskPhoneNumber(phone);
        },
        handleImage(image) {
            return validateImageUrl(image);
        },
    },
};
</script>

<style scoped>
.parkBox {
    width: 100%;
    height: auto;
    margin-top: 25px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 21px;
}

.parkImgBox {
    width: 100%;
    height: auto;
    display: flex;
    column-gap: 8px;
    overflow: hidden;
    overflow-x: auto;
    padding-bottom: 10px;
}
</style>